import { Component, Host, h, Prop } from '@stencil/core';
import { renderResponsiveImages } from '../../helpers/helpers';
import type { ResponsiveImages } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-text-image',
  styleUrl: 'cms-text-image.scss',
  shadow: true,
})
export class CmsTextImage {
  private responsiveImages: ResponsiveImages;
  private imageSizes = {
    full: '(min-width: 320px) 100vw,(min-width: 1280px) 1280px,',
    'two-thirds': '(min-width: 768px) calc(66vw - 60px)',
  };

  private imageStyles = {
    width: '100%',
    height: 'auto',
    display: 'block',
  };

  /**
   * set the content
   */
  @Prop({ mutable: true }) content: string;

  /**
   * set the layout
   */
  @Prop({ reflect: true }) layout: 'full' | 'two-thirds' = 'full';

  /**
   * set the picture
   */
  @Prop() images: ResponsiveImages | string;

  /**
   * set the picture-description
   */
  @Prop({ mutable: true }) pictureDescription: string;

  /**
   * set the picture-description
   */
  @Prop({ mutable: true }) pictureAlt: string;
  /**
   * set the picture-description
   */
  @Prop({ mutable: true }) picturePosition: 'top' | 'bottom' = 'top';

  componentWillLoad() {
    if (typeof this.images === 'string' && this.images !== '') {
      this.responsiveImages = JSON.parse(this.images) as ResponsiveImages;
    }
  }

  render() {
    return (
      <Host>
        <div class='container'>
          <div class='text-wrapper' innerHTML={this.content} />
          {this.images ? (
            <div class='picture-wrapper'>
              {renderResponsiveImages(
                this.responsiveImages,
                this.imageSizes[this.layout],
                this.pictureAlt,
                'work-step-image',
                this.imageStyles,
              )}
              {this.pictureDescription ? (
                <div class='picture-description'>{this.pictureDescription}</div>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      </Host>
    );
  }
}
